import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EditIcon from '@mui/icons-material/Edit';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import React from 'react';

import { BulkActionsBarProps } from './BulkActionsBar.props';

const ACTION_BUTTONS = [
  { key: 'bulk_update', label: 'Bulk Update', icon: <EditIcon sx={{ fontSize: 16 }} /> },
  { key: 'add_note', label: 'Add Note', icon: <NoteAddIcon sx={{ fontSize: 16 }} /> },
  { key: 'assign_tech', label: 'Assign Tech', icon: <PersonAddIcon sx={{ fontSize: 16 }} /> },
  { key: 'schedule', label: 'Schedule', icon: <CalendarTodayIcon sx={{ fontSize: 16 }} /> },
  { key: 'open_tabs', label: 'Open in Tabs', icon: <OpenInNewIcon sx={{ fontSize: 16 }} /> },
] as const;

const BUTTON_SX = {
  color: 'common.white',
  borderColor: 'divider',
  fontSize: '12px',
  textTransform: 'none' as const,
  px: 1.5,
  py: 0.5,
  opacity: 0.85,
  '&:hover': {
    borderColor: 'common.white',
    bgcolor: 'action.hover',
    opacity: 1,
  },
} as const;

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  count,
  onAction,
  onClear,
}) => {
  if (count <= 0) return null;

  return (
    <Box
      role="toolbar"
      aria-label="Bulk actions bar"
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        left: 0,
        bgcolor: 'v4.sidebarActive',
        color: 'common.white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 1.25,
        zIndex: 1300,
        boxShadow: '0 -4px 16px rgba(0,0,0,.15)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>
          {count} selected
        </Typography>
        {ACTION_BUTTONS.map((btn) => (
          <Button
            key={btn.key}
            variant="outlined"
            size="small"
            startIcon={btn.icon}
            onClick={() => onAction(btn.key)}
            sx={BUTTON_SX}
          >
            {btn.label}
          </Button>
        ))}
      </Box>
      <Link
        component="button"
        onClick={onClear}
        sx={{
          color: 'common.white',
          opacity: 0.7,
          fontSize: '12px',
          cursor: 'pointer',
          textDecoration: 'underline',
          '&:hover': { color: 'common.white', opacity: 1 },
        }}
      >
        Clear Selection
      </Link>
    </Box>
  );
};
